import React from 'react'
import PropTypes from 'prop-types'
import { FormattedDate } from 'react-intl'

import { omit } from 'common/utils/objectUtils'
import R2RDateTime from 'common/utils/R2RDateTime/R2RDateTime'

const R2RFormattedDate = (props) => {
  // note: normalized with UTC
  // it's very important that the timezone of the "value" prop and the "timezone" prop match
  const dateTime = props.dateTime.toMomentUTC()

  // this should be the ONLY use of FormattedDate in the product.
  // timezones are too easy to mess with, so we're consolidating all of the logic to
  // this one place
  return (<FormattedDate
    value={dateTime}
    timeZone="utc"
    {...omit(props, 'dateTime', 'timezone')}
  />)
}

// most proptypes from https://github.com/yahoo/react-intl/wiki/Components#date-formatting-components
R2RFormattedDate.propTypes = {
  dateTime: PropTypes.instanceOf(R2RDateTime),
  weekday: PropTypes.oneOf(['narrow', 'short', 'long']),
  year: PropTypes.oneOf(['numeric', '2-digit']),
  month: PropTypes.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: PropTypes.oneOf(['numeric', '2-digit']),
}

export default R2RFormattedDate
